export function getError(error: any) {
    let errorData = error.response?.data
    return errorData.message?.error || errorData.exception.split(":").slice(1).join(" ") ||"une erreur est survenu"

}